export const COMPANY_PERMISSIONS = {
  getCompanies: 'getCompanies',
  getCompany: 'getCompany',
  updateCompany: 'updateCompany',
  getServiceCentersAdmin: "getServiceCentersAdmin",
  getCompanyAdditionalOptions: "getCompanyAdditionalOptions",
  addCompanyAdditionalOption: "addCompanyAdditionalOption",
  updateCompanyAdditionalOption: "updateCompanyAdditionalOption",
}